// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3i4aO","empty":"ModalGraph_empty__i4Ysb"};